var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 11.4291,
    cy: 5.82091,
    r: 1.28606,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 1.28606,
    cy: 1.28606,
    r: 1.28606,
    transform: "matrix(-1 0 0 1 5.85645 4.53485)",
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9999,
    cy: 5.82092,
    r: 1.71475,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3859 11.3939C11.0448 11.3939 11.5975 10.8683 11.3819 10.2717C11.2063 9.78583 10.9173 9.33931 10.5306 8.96883C9.85941 8.32568 8.94905 7.96436 7.99981 7.96436C7.05057 7.96436 6.14021 8.32568 5.46899 8.96883C5.08235 9.33931 4.7933 9.78583 4.61771 10.2717C4.4021 10.8683 4.95484 11.3939 5.61373 11.3939L10.3859 11.3939Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.4414 7.53568C12.1494 7.53568 12.8284 7.80651 13.3291 8.2886C13.6176 8.56647 13.8338 8.90174 13.9648 9.26614C14.1257 9.71356 13.7132 10.1079 13.2217 10.1079H12.2715C12.2966 9.9821 12.2896 9.84695 12.2393 9.70755C12.0637 9.22167 11.7743 8.7753 11.3877 8.40482C11.099 8.12817 10.7665 7.90287 10.4053 7.73685C10.7301 7.60512 11.0821 7.53568 11.4414 7.53568Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.63281 7.53568C3.9038 7.53568 3.20398 7.80627 2.68848 8.2886C2.39155 8.56644 2.17002 8.90178 2.03516 9.26614C1.86958 9.71355 2.29381 10.1079 2.7998 10.1079H3.71387C3.68898 9.98211 3.69522 9.84694 3.74512 9.70755C3.91913 9.22181 4.20575 8.77524 4.58887 8.40482C4.89105 8.11272 5.24264 7.87887 5.62402 7.71048C5.31067 7.59701 4.9753 7.53571 4.63281 7.53568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.d6f0db56350cafab203f90eba2b56cc9.svg";
export { ForwardRef as ReactComponent };